import React from "react";
import { motion } from "framer-motion";
import { APPLY_URL } from "./constants";
import { ArrowUpRight } from "lucide-react";
import FlowerOfLife from "./FlowerOfLife";

const FinalCTA = () => {
    return (
        <section
            data-testid="final-cta"
            className="relative overflow-hidden bg-[#0a0c27]"
        >
            {/* Top gold beam */}
            <div className="absolute -inset-x-10 top-0 h-1 bg-gradient-to-r from-transparent via-[#f2c652] to-transparent" />

            {/* Flower of life centered behind */}
            <div
                className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.22]"
                aria-hidden="true"
            >
                <div className="w-[95vmin] h-[95vmin] dn-rotate-slow">
                    <FlowerOfLife
                        color="#d4af37"
                        opacity={0.9}
                        strokeWidth={0.45}
                        className="w-full h-full"
                    />
                </div>
            </div>

            {/* Radial gold glow */}
            <div className="absolute inset-0 bg-[radial-gradient(60%_50%_at_50%_50%,rgba(212,175,55,0.18),transparent_70%)]" />

            <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-36 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="text-xs uppercase tracking-[0.4em] text-[#f2c652] font-display mb-6">
                        Last Call
                    </div>
                    <h2 className="font-display font-black tracking-tighter text-5xl sm:text-7xl md:text-8xl lg:text-[128px] leading-[0.85] text-[#f6f1e1] max-w-6xl mx-auto">
                        Join the circle.
                        <br />
                        Find your{" "}
                        <span className="font-serif-italic font-light bg-gradient-to-br from-[#f2c652] to-[#fca112] bg-clip-text text-transparent">
                            people.
                        </span>
                    </h2>
                    <p className="mt-8 text-[#f6f1e1]/60 font-body text-base md:text-lg max-w-xl mx-auto">
                        If you were invited, you already know why you're here.
                        The only thing left is to apply.
                    </p>

                    <a
                        href={APPLY_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="final-apply-cta"
                        className="mt-10 group inline-flex items-center gap-3 bg-gradient-to-br from-[#f2c652] to-[#d4af37] hover:from-[#fcc001] hover:to-[#f2c652] text-[#0a0c27] font-display font-semibold text-base md:text-lg px-7 md:px-8 py-4 md:py-5 rounded-sm transition-all hover:-translate-y-0.5 shadow-[0_25px_70px_-18px_rgba(242,198,82,0.7)]"
                    >
                        Apply Now · $24.99/month If Approved
                        <ArrowUpRight className="w-5 h-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default FinalCTA;
